import {useQuery} from '@tanstack/react-query'
import {getSubscription} from '@api/subscription.js'
import {checkAuth, getAuthData} from '@utils/auth.js'
import {normalizeSubscriptionSnapshot} from '../subscription/runtime.js'

export default function useSubscription() {
  const isAuth = checkAuth()
  const query = useQuery({
    queryKey: ['subscription'],
    queryFn: getSubscription,
    enabled: isAuth,
    staleTime: 0,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    retry: 1
  })

  if (!isAuth) return null

  const liveSnapshot = normalizeSubscriptionSnapshot(query.data)
  if (liveSnapshot) {
    return liveSnapshot
  }

  return normalizeSubscriptionSnapshot(getAuthData()?.user)
}
